export const DATE_FORMAT_DATETIME = 'dd-MM-yyyy, HH:mm';
export const DATE_FORMAT_DATE = 'dd-MM-yyyy';
export const DATE_FORMAT_PICKER = 'dd-MM-yyyy'; // date-fns tokens (renders identically to the old moment 'DD-MM-YYYY')

export const MOBILE_HEADER_HEIGHT = 85;
export const MAX_FORMULA_INT = 9223372036854775807;

// Must not exceed the API validation / column limits (scenario notes & control description 2048, impact 1024)
export const CHAR_LIMITS = {
  scenarioName: 255,
  scenarioNote: 2000,
  controlDescription: 2000,
  incidentDescription: 2000,
  incidentImpact: 1000,
} as const;

export const charLimitError = (fieldName: string) => `You have entered too many characters in "${fieldName}"`;

export const MOTION_TRANSITION = { type: 'tween', duration: 0.2 };

export const isDev = process.env.NODE_ENV === 'development';
export const API_DEBUG = true;

const getEnvironment = (): 'development' | 'test' | 'staging' | 'production' => {
  if (isDev) {
    return 'development';
  }

  const url = window.location.origin.toLowerCase();

  if (url.includes('test.cydea')) {
    return 'test';
  }

  if (url.includes('staging.cydea')) {
    return 'staging';
  }

  return 'production';
};

export const env = getEnvironment();
